/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
import Vue from 'vue';
import App from './App.vue';
import FastClick from 'fastclick';
import router from './router/index';
import RouterGuide from '@/interceptor/router.js';
import store from './store/index';
import plugin from '@/plugin/index';
import * as filters from './filters/';
import { sync } from 'vuex-router-sync';
import './static/css/reset.css';
import './static/js/flexible.js';
import './static/css/animate.css';
import './static/css/global.less';
import 'swiper/dist/css/swiper.css';
import './icons';
import vant from '@/config/vant.js';
import vueSwiper from 'vue-awesome-swiper';
import vueJsonp from 'vue-jsonp';
import Xrk from 'xrk-components';
import ElementUi from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';
import * as directives from '@/directives/index';
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

Vue.use(vueJsonp);
import config from '@/config/index';
Vue.config.productionTip = false;
// FastClick.attach(document.body);
sync(store, router);
document.domain = config.domain;
/* 样式的话，我这里有用到分页器，就在全局中引入了样式 */
Vue.use(vueSwiper);
Vue.use(plugin);
Vue.use(vant);
Vue.use(ElementUi);
Vue.use(vueJsonp);
Vue.use(Xrk);
Vue.prototype.$sa.init();
// Vue.prototype.$ajax = Ajax
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.use(RouterGuide);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
